import { module } from 'angular';
import smartFieldComponent from './smart-field.component';
import './smart-field.scss';
import smartFieldInputDirective from './smart-field-input.directive';

export default module('app')
	.component('smartField', smartFieldComponent)
	.directive('smartFieldInput', smartFieldInputDirective)
	.name;
